import jsPsychAudioButtonResponse from '@jspsych/plugin-audio-button-response';
import store from 'store2';
import { initAppTimer, mediaAssets } from '../helperFunctions';
import '../../styles/custom.scss';

/* define instructions trial */
const intro_1 = {
  type: jsPsychAudioButtonResponse,
  on_start: () => initAppTimer(),
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['01Intro'];
    }
    return mediaAssets.audio.intro1Ns;
  },
  prompt: function () {
    if (store.session.get('config').story) {
      return ` <div class = "instructionText">
        <h1>Welcome to a new planet we just discovered—with friendly aliens called Zorps!</h1>
      <img class="scene" src="${mediaAssets.images.backgroundSpace}"
      <div>
        <p class = "center"> Zorps are interested in learning more about the kinds of things we have on Earth. </p> 
        <p class = "center"> And as you help them learn, they're going to take us on a tour of their planet. </p>
        <p class = "center"> Can you help? Which alien do you want to journey with? </p>
        <p class = "center"> <b>Choose one alien for your journey.</b></p>
      </div>
      </div> `;
    }
    return `
      <div class = "instructionText">
        <h1> Welcome to the Vocabulary activity! </h1>
        <p> In this activity, you are going to listen to words and look at different pictures. </p>
        <p> <b> Your job is to pick the picture that matches the word! </b> </p>
        <img draggable="false" class="instructionCanvasNS" src="${mediaAssets.images.pictureClick}" alt="canvas 1">
      </div>
    `;
  },
  choices: () => {
    if (store.session.get('config').story) {
      return [
        mediaAssets.images.alienYellowWalking,
        mediaAssets.images.alienBlueWalking,
        mediaAssets.images.alienGreenWalking,
      ];
    }
    return [mediaAssets.images.go];
  },
  button_html: () => {
    if (store.session.get('config').story) {
      return '<img class="intro_aliens" draggable="false" src="%choice%" alt="response" />';
    }
    return '<img class="continue" draggable="false" src="%choice%" />';
  },
  on_finish: function (data) {
    if (store.session.get('config').story) {
      if (data.response === 0) {
        store.session.set('alienColor', 'Yellow');
      } else if (data.response === 1) {
        store.session.set('alienColor', 'Blue');
      } else {
        store.session.set('alienColor', 'Green');
      }
    }
  },
};

const intro_2 = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['02IntroT'];
    }
    return mediaAssets.audio.intro2Ns;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      return `
      <div>
       <h1> Great! </h1>
       <div>
       <p class="center"> They're going to show us some different pictures. For example, a picture of an apple and a picture of a carrot. </p>
       <p class="center"> Then, you'll hear a word for one of the pictures. </p>
       <p class="center"> <b>Your job is to pick the picture that matches the word! </b></p>
      </div>
      <img draggable="false" class="instructionCanvas" src="${mediaAssets.images.gameInterface}" alt="canvas 1">
      </div>`;
    }
    return `
    <div>
     <h1> Practice </h1>
     <div>
     <p class="center"> You are going to see some different pictures. For example, a picture of an apple and a picture of a carrot. </p>
     <p class="center"> Then, you'll hear a word for one of the pictures. </p>
     <p class="center"> <b> Make sure to pick the picture that matches the word! </b></p>
    </div>
    <img draggable="false" class="instructionCanvas" src="${mediaAssets.images.gameInterface}" alt="canvas 1">
    </div>`;
  },
  trial_ends_after_audio: () => {
    if (store.session.get('config').story) {
      return true;
    }
    return false;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
};

const intro_3 = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['03Intro1'];
    }
    return mediaAssets.audio.intro3Ns;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      const alien = `alien${store.session('alienColor')}Confusing`;
      return `
      <div>
      <h1> Try to do your best! </h1>
      <div>
        <img class="speaker" src="${mediaAssets.images.iconSpeaker}" alt="animation of a wizard waving a magic wand">
        <p class="center"> Some words are hard, and that's okay. If you're not sure, just give your best guess! </p>
        <br>
        <br>
        <p class="center"> If you need to hear the word again, press the speaker button. </p>
        <img class="coin_feedback" src="${mediaAssets.images[alien]}" />
      </div>
      </div>`;
    }
    return `
    <div>
    <h1> Try to do your best! </h1>
    <div>
      <p class="center"> Some words are hard, and that's okay. If you're not sure, just give your best guess! </p>
      <br>
      <br>
      <p class="center"> If you need to hear the word again, press the speaker button. </p>
      <img class="coin_feedback" src="${mediaAssets.images.iconSpeaker}" />
      </div>
      </div>`;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
  trial_ends_after_audio: () => {
    if (store.session.get('config').story) {
      return true;
    }
    return false;
  },
};

const intro_4 = {
  type: jsPsychAudioButtonResponse,
  stimulus: mediaAssets.audio['03IntroT'],
  prompt: function () {
    return `
   <img class="instructionCanvas" src="${mediaAssets.images.backgroundStarsky}"</img>
   <h4>When you teach the words, the aliens are so happy that they light up some stars in the sky!</h4>
   `;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
  trial_ends_after_audio: true,
};

const if_intro_4 = {
  timeline: [intro_4],
  conditional_function: () => Boolean(store.session.get('config').task !== 'cdm'),
};

export const post_practice_intro = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').story) {
      return mediaAssets.audio['06ReadyT'];
    }
    return mediaAssets.audio.readyNs;
  },
  prompt: () => {
    if (store.session.get('config').story) {
      return `
      <div>
      <h1> Awesome! </h1>
      <h5> Are you ready to begin the journey? </h5>
      <img class="coin_feedback" src="${mediaAssets.images[`alien${store.session('alienColor')}Waving`]}" />
      </div>`;
    }
    return `
    <div>
    <h1> Awesome! </h1>
    <p> Let's start the real activity now. </p>
    <img draggable="false" class="instructionCanvasNS" src="${mediaAssets.images.pictureClick}" alt="canvas 1">
    </div>`;
  },
  choices: [mediaAssets.images.go],
  button_html: '<img class="continue" draggable="false" src="%choice%" />',
  trial_ends_after_audio: () => {
    if (store.session.get('config').story) {
      return true;
    }
    return false;
  },
};

/* coin tracking trial */
const coin_tracking_feedback = {
  type: jsPsychAudioButtonResponse,
  stimulus: mediaAssets.audio.fairyCoin,
  prompt: `<div class = "stimulus_div"><img src="${mediaAssets.images.backgroundShootingstar}"> ></div>`,
  choices: [],
  trial_duration: 2000,
};

export const introduction_trials = {
  timeline: [intro_1, intro_2, intro_3, if_intro_4],
};

export const introduction_trials_ns = {
  timeline: [intro_1, intro_2, intro_3],
};

export const if_coin_tracking = {
  timeline: [coin_tracking_feedback],
  conditional_function: function () {
    const coinTrackingIndex = store.session('coinTrackingIndex');
    if (store.session('currentTrialCorrect') && coinTrackingIndex >= 7) {
      store.session.set('coinTrackingIndex', 0);
      return true;
    }
    store.session.set('coinTrackingIndex', coinTrackingIndex + 1);
    return false;
  },
};
